import {
  WorkflowTimezone,
  type WorkflowContactWindow,
} from 'src/interfaces/workflows.interface';

const TIMEZONE_LABELS: Record<WorkflowTimezone, string> = {
  [WorkflowTimezone.AMERICA_LOS_ANGELES]: 'Pacific Time',
  [WorkflowTimezone.AMERICA_DENVER]: 'Mountain Time',
  [WorkflowTimezone.AMERICA_CHICAGO]: 'Central Time',
  [WorkflowTimezone.AMERICA_NEW_YORK]: 'Eastern Time',
  // Included for completeness; caller can request condensed wording.
  [WorkflowTimezone.CONTACT_LOCAL]: "Contact's Local Timezone",
};

export function getEffectiveTimeZone(
  contactWindow: Pick<WorkflowContactWindow, 'primaryTz' | 'fallbackTz'>,
): WorkflowTimezone | undefined {
  if (contactWindow.primaryTz === WorkflowTimezone.CONTACT_LOCAL) {
    return contactWindow.fallbackTz ?? undefined;
  }

  return contactWindow.primaryTz;
}

export function formatWorkflowTimezone(
  timeZone: WorkflowTimezone,
  options?: { condensed?: boolean },
): string {
  if (timeZone === WorkflowTimezone.CONTACT_LOCAL) {
    return options?.condensed ? "Contact's Local" : "Contact's Local Timezone";
  }

  return TIMEZONE_LABELS[timeZone];
}
